module.exports = __webpack_public_path__ + "img/googlemap.62e826ec.jpg";